/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lot: NonNullable<unknown>, name: NonNullable<unknown>, quantity: NonNullable<unknown>, unit: NonNullable<unknown> }} Sinp_Bags_Row_LabelInputs */

const vi_sinp_bags_row_label = /** @type {(inputs: Sinp_Bags_Row_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.lot} — ${i?.name} (${i?.quantity} ${i?.unit})`)
};

/**

* @param {Sinp_Bags_Row_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_bags_row_label = /** @type {((inputs: Sinp_Bags_Row_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Bags_Row_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_bags_row_label(inputs)
});